import { render, staticRenderFns } from "./JobDetailsList.vue?vue&type=template&id=0c6544d9&"
import script from "./JobDetailsList.vue?vue&type=script&lang=ts&"
export * from "./JobDetailsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports